import axios from 'axios'
import { AppHolder } from '@/utils/app-holder'
import humps from 'humps'
import notifications from './modules/notifications'
import CableWrapper from './cable-wrapper'
import clone from 'lodash/cloneDeep'
import Cookie from '@/utils/cookie'

const client = axios.create({
  baseURL: `${process.env.BASE_URL}/v1`,
  withCredentials: true
})

client.interceptors.request.use(request => {
  request.data = humps.decamelizeKeys(request.data)
  return request
})

if (Cookie.get('accessToken')) {
  // allow to stay authenticated when refreshing the page or if token still valid
  const headers = clone(client.defaults.headers)
  headers.common['Authorization'] = `Bearer ${Cookie.get('accessToken')}`
  client.defaults.headers = headers
}

client.interceptors.response.use(({ data }) => {
  return humps.camelizeKeys(data)
}, error => {
  error = humps.camelizeKeys(error)
  AppHolder.store.dispatch('error/setError', error)

  // TODO : DEVISE ERROR FORMAT TEMPORARY FIX
  if (error.response && error.response.data.error) {
    error.response.data.errors = { global: [error.response.data.error] }
  }

  error.fields = error.response ? error.response.data.errors : []
  throw error
})

export const cable = new CableWrapper(client)
// export const cable = ActionCable.createConsumer(`${process.env.BASE_WEBSOCKET}/cable?toto=45`)

export function requestApi (host) {
  const biApi = axios.create({
    baseURL: host
  })

  biApi.interceptors.request.use(request => {
    request.data = humps.decamelizeKeys(request.data)
    return request
  })

  biApi.interceptors.response.use(({ data }) => {
    return humps.camelizeKeys(data)
  }, error => {
    error = humps.camelizeKeys(error)
    AppHolder.store.commit('error/setError', error)

    // TODO : DEVISE ERROR FORMAT TEMPORARY FIX
    if (error.response && error.response.data.error) {
      error.response.data.errors = { global: [error.response.data.error] }
    }

    error.fields = error.response ? error.response.data.errors : []
    throw error
  })

  return biApi
}

export function subscribe () {
  notifications.subscribe()
}

export function unsubscribe () {
  notifications.unsubscribe()
  cable.disconnect()
}

export default client
